module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_rogaland_neg.fc8f15e4.png";